import { cn } from '@/platform/lib/utils';
import { forwardRef } from 'react';

const NavigationItem = forwardRef(
    ({ as, children, className, ...props }, ref) => {
        const Component = as ?? (props.onClick ? 'button' : 'div');

        return (
            <Component
                ref={ref}
                className={cn(
                    'flex items-center gap-x-2 self-stretch px-4 transition-colors duration-200',
                    ['button', 'a'].includes(Component) &&
                        'cursor-pointer hover:bg-gray-100',
                    className
                )}
                {...props}
            >
                {children}
            </Component>
        );
    }
);

NavigationItem.displayName = 'NavigationItem';

export default NavigationItem;
